import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import './forgot.css'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { LocalForm, Control } from 'react-redux-form'
import Errors from '../../components/common/errors'
import { Row, Col, FormGroup, Input } from 'reactstrap'
import Match from '../../utilities/validation'
import { Link } from 'react-router-dom'
import {
    invalidPass,
    newPassword,
  
    confirmPasswordNew,
    invalid6,
    invalid7,
    passMatch,
    invalid2,
    invalid4,
    invalid5,
    invalid3,
} from '../../utilities/message'
import { Modal } from '@mui/material'
import ModalClose from '@mui/joy/ModalClose'

import { resetPassword } from '../../actions/user'
import Loader from '../../components/Loader'

const ChangePassword = ({  history }) => {
    const loaders = useSelector((state) => state.loader)
    const [openModal, setModal] = useState(false)
    const [pass, setPass] = useState(true)
    const [changepass, setChangePass] = useState(true)
    const [error, setError] = useState(null)
    const dispatch = useDispatch()
    const user = useSelector((state) => state.user)
    const [passVal, setPassVal] = useState('')

    //***********MODAL******************* */
    const handleModal = () => {
        setModal(!openModal)
    }
    
    const styleDeletePopup = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 366,
        borderRadius: 10,
        bgcolor: 'background.paper',
        pt: 2,
        px: 4,
        pb: 3,
    }

    const handleChangeForm = (values) => {
        if (
            values.password &&
            values.confirmpassword &&
            values.password.trim() === values.confirmpassword.trim()
        ) {
            setError(null)
        } else {
            if (values.confirmpassword && values.confirmpassword != ' ') {
                setError(passMatch)
            } else {
                setError(null)
            }
        }
    }

    const submitForgot = (values) => {
        if (values.password.trim() === values.confirmpassword.trim()) {
            dispatch(
                resetPassword({ ...values, ...{ email: user.forgot_email } }, (res) => {
                    if (res) {
                        setError(null)
                        handleModal()
                    }
                }),
            )
        } else {
            setError(passMatch)
        }
    }
    const handleChange = (e) => {
        e.preventDefault()
    }

    return (
        <React.Fragment>
            <div>
                <Loader loading={loaders.isFetching} />

                <div className="forgotHeader">
                    <div className="logo-details">
                        <div onClick={()=>history.push('/dashboard')}  className="logo2">
                            <img alt="logo" height={120} src={require('../../assets/images/newfile/Property 1=Variant2 (1).svg').default} />
                        </div>
                    </div>
                </div>
                <div className="forgotDiv">
                    <Box className="forgotPopup2">
                        <div className="forgoticonshadow">
                            <i className=" greenlockIcon">
                                <img src={require('../../assets/images/greenlock.png')} />
                            </i>
                        </div>
                        <div className="textForgotPopup">
                            <Typography id="modal-modal-title" variant="h6" component="h2">
                                Create New Password
                            </Typography>
                            <Typography
                                id="modal-modal-description"
                                className="changepassworddescription"
                                sx={{ mt: 2 }}
                            >
                                Your new password must be different from your currently used
                                password.
                            </Typography>

                            <Typography className="changepass">
                                <LocalForm
                                    model="user"
                                    onSubmit={(values) => submitForgot(values)}
                                    onChange={(values) => handleChangeForm(values)}
                                >
                                    <Row>
                                        <Col sm="12" md="12">
                                            <FormGroup>
                                                <div className="input-wrapper">
                                                    <i class=" icon">
                                                        <img
                                                            src={require('../../assets/images/newfile/password icon.svg').default}
                                                        />
                                                    </i>
                                                    <Control.text
                                                        model="user.password"
                                                        className="form-control input-field password"
                                                        id="user.password"
                                                        value={passVal}
                                                        maxLength={20}
                                                        type={pass ? 'password' : 'text'}
                                                        onChange={(e) => setPassVal(e.target.value)}
                                                        placeholder="New Password"
                                                        onPaste={(e) => handleChange(e)}
                                                        onCopy={(e) => handleChange(e)}
                                                        errors={{
                                                            newPassword: (val) => !val,
                                                            invalidPass: (val) =>
                                                                val && !Match.validatePassword(val),
                                                            invalid2: (val) =>
                                                                val && !Match.validatePassword(val),
                                                            invalid3: (val) =>
                                                                val && !Match.validatePassword(val),
                                                            invalid4: (val) =>
                                                                val && !Match.validatePassword(val),
                                                            invalid5: (val) =>
                                                                val && !Match.validatePassword(val),
                                                            invalid6: (val) =>
                                                                val && !Match.validatePassword(val),
                                                            invalid7: (val) =>
                                                                val && !Match.validatePassword(val),
                                                        }}
                                                    ></Control.text>
                                                    {pass && (
                                                        <i
                                                            class=" iconeye"
                                                            onClick={() => setPass(false)}
                                                        >
                                                            <img
                                                                src={require('../../assets/images/newfile/hide password.svg').default}
                                                            />
                                                        </i>
                                                    )}

                                                    {!pass && (
                                                        <i
                                                            class=" iconeye"
                                                            onClick={() => setPass(true)}
                                                        >
                                                            <img
                                                                src={require('../../assets/images/newfile/show password.svg').default}
                                                            />
                                                        </i>
                                                    )}
                                                </div>
                                                <Errors
                                                    model="user.password"
                                                    style={{ width: '408px' }}
                                                    errors={{
                                                        newPassword,
                                                        invalidPass,
                                                        invalid2,
                                                        invalid3,
                                                        invalid4,
                                                        invalid5,
                                                        invalid6,
                                                        invalid7,
                                                    }}
                                                />
                                            </FormGroup>
                                        </Col>

                                        <Col sm="12" md="12">
                                            <FormGroup>
                                                <div className="input-wrapper">
                                                    <i class=" icon">
                                                        <img
                                                            src={require('../../assets/images/newfile/password icon.svg').default}
                                                        />
                                                    </i>
                                                    <Control.text
                                                        model="user.confirmpassword"
                                                        className="form-control input-field password"
                                                        id="user.confirmpassword"
                                                        maxLength={20}
                                                        type={changepass ? 'password' : 'text'}
                                                        placeholder="Confirm Password"
                                                        onPaste={(e) => handleChange(e)}
                                                        onCopy={(e) => handleChange(e)}
                                                        errors={{
                                                            confirmPasswordNew: (val) => !val,
                                                            // confirmPassword:(val) => val &&  val != passVal
                                                        }}
                                                    ></Control.text>
                                                    {changepass && (
                                                        <i
                                                            class=" iconeye"
                                                            onClick={() => setChangePass(false)}
                                                        >
                                                            <img
                                                                src={require('../../assets/images/newfile/hide password.svg').default}
                                                            />
                                                        </i>
                                                    )}
                                                    {!changepass && (
                                                        <i
                                                            class=" iconeye"
                                                            onClick={() => setChangePass(true)}
                                                        >
                                                            <img
                                                                src={require('../../assets/images/newfile/show password.svg').default}
                                                            />
                                                        </i>
                                                    )}
                                                </div>
                                                <Errors
                                                    model="user.confirmpassword"
                                                    errors={{
                                                        confirmPasswordNew,
                                                        invalidPass,
                                                    }}
                                                />
                                                {error && (
                                                    <p
                                                        style={{
                                                            color: 'red',
                                                            display: 'flex',
                                                            'align-items': 'flex-start',
                                                        }}
                                                    >
                                                        Confirm Password doesn't match with New
                                                        Password
                                                    </p>
                                                )}
                                            </FormGroup>
                                        </Col>
                                        <Col sm="12 form-button-spacing">
                                            <button
                                                type="submit"
                                                className="btn btn-primary btn-block "
                                            >
                                                Create
                                            </button>
                                        </Col>
                                        <Link to="/">
                                            <Col sm="12 form-button-spacing backlogin">
                                                <p>
                                                    <img
                                                        src={require('../../assets/images/back.png')}
                                                    />
                                                </p>
                                                <p>Back to login</p>
                                            </Col>
                                        </Link>
                                    </Row>
                                </LocalForm>
                            </Typography>
                        </div>
                    </Box>
                </div>
            </div>

            <Modal
                open={openModal}
                onClose={handleModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleDeletePopup} className="deletePopup">
                    <ModalClose onClick={() => history.push('/')} />

                    <div className="iconshadow">
                        <i className=" congratulationsForgotEnd">
                            <button>
                                <img src={require('../../assets/images/Group 427319061.png')} />
                            </button>
                        </i>
                    </div>
                    <div className="textDeletePopup">
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            Congratulations
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                            You have successfully changed your password.
                        </Typography>

                        <Typography>
                            <div className="buttonGroupDelete">
                                <button
                                    className="btn btn-primary btn-block okaybutton"
                                    onClick={() => history.push('/')}
                                >
                                    Okay
                                </button>
                            </div>
                        </Typography>
                    </div>
                </Box>
            </Modal>
        </React.Fragment>
    )
}

export default ChangePassword
